export default function isPacketSizeTooLarge(error) {
  return error?.includes('grpc: received message larger than max');
}
